import { call, put, select, takeLatest } from 'redux-saga/effects';
import { InsightActionTypes } from './insightTypes';
import { insightApiResponseSuccess, insightApiResponseError } from './insightActions';
import { distillApi } from '../api/distillNode';
import { RootState } from '../store';

function* distillSaga(action: any): any {
  try {
    const { thought } = action.payload;
    const response = yield call(distillApi, thought);
    yield put(
      insightApiResponseSuccess(InsightActionTypes.DISTILL, {
        ...response.data ?? response,
        rawThought: thought,
      }),
    );
  } catch (error: any) {
    yield put(
      insightApiResponseError(
        InsightActionTypes.DISTILL,
        error?.response?.data?.error || error?.message || 'Distill failed',
      ),
    );
  }
}

export default function* insightSaga() {
  yield takeLatest(InsightActionTypes.DISTILL, distillSaga);
}
